import type { Lazy } from 'fp-ts/lib/function';
import { useRef } from 'react';

const nothing = Symbol('uninitialized stable value');

/**
 * Use once-initialized stable value
 *
 * Basically useRef accepting a factory and returning the boxed value directly
 */
export const useStableValue = <T,>(init: Lazy<T>): T => {
  const ref = useRef<T | typeof nothing>(nothing);
  if (ref.current === nothing) {
    ref.current = init();
  }
  return ref.current;
};
